import React, {useCallback, useEffect, useRef, useState} from 'react';
import {inject, observer} from 'mobx-react';
import format from "date-fns/format";
import {db} from "../../../../firebase/Firebase";
import PromotionsForm from "./PromotionsForm";
import PromotionsEditForm from "./PromotionsEditForm";
import {Animated} from "react-animated-css";
import PromotionGrid from "./PromotionGrid";

const actualDataYear = format(new Date(), 'yyyy')

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function Promotions(props) {

    const {DataStore} = props;

    const {companyName, idCompany, userName, userMail, contactNumbers, imageAsUrl} = DataStore

    const [promotions, setPromotions] = useState([])
    const [visible, setVisible] = useState(false);
    const [edit, setEdit] = useState(false);
    const [dataEdit, setDataEdit] = useState(null);
    const [trigger, setTrigger] = useState(false);
    const [actualYear, setActualYear] = useState(actualDataYear);
    const [popupVisible, setPopupVisible] = React.useState(false);
    const [load, setLoad] = useState(false)
    const [visibleGrid, setVisibleGrid] = useState(true)
    const [visibleForm, setVisibleForm] = useState(false)

    const isMounted = useMountedState()

    const mainPath = db.collection(companyName).doc(idCompany).collection('Promotions')

    useEffect(() => {

        const GetPromotions = async () => {
            let ID = 0
            await mainPath.where('year', '==', actualYear).onSnapshot((querySnapshot) => {
                const newArray = [];
                querySnapshot.forEach(doc => {
                    if (doc.exists) {
                        ID = ID + 1
                        let value;
                        if (doc.data().value) {
                            value = doc.data().value
                        } else {
                            value = 0
                        }
                        const start = new Date(doc.data().start.seconds * 1000)
                        const end = new Date(doc.data().end.seconds * 1000)

                        const now = new Date()

                        const state = format(now, 'yyyy-MM-dd') <= format(end, 'yyyy-MM-dd')

                        const obj = {
                            ...doc.data(), docId: doc.id, ID: ID, start: start, end: end, value: value,
                            state: state ? doc.data().state : 'Inactiva'
                        };
                        newArray.push(obj);
                        setLoad(true)
                    } else {
                        setPromotions([]);
                        setLoad(true)
                    }
                })
                setPromotions(newArray);
                setLoad(true)
            })
        }

        if (isMounted()) {
            GetPromotions().catch(() => setTrigger(!trigger));
        }
    }, [trigger])

    const onSendPromotion = (e) => {
        const state = e.row.data.state;
        setDataEdit(e.row.data);
        if (state === 'Registrado') {
            setPopupVisible(true);
        }
    };

    return (
        <>
            {visibleGrid &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleGrid}>
                <PromotionGrid load={load} dataSource={promotions} setEdit={setEdit}
                               setVisibleForm={setVisibleForm} setVisibleGrid={setVisibleGrid}
                               setDataEdit={setDataEdit} DataStore={DataStore} setTrigger={setTrigger}
                               trigger={trigger}/>
            </Animated>}

            {visibleForm &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleForm}>
                <PromotionsForm setVisibleForm={setVisibleForm} setTrigger={setTrigger} trigger={trigger}
                                DataStore={DataStore} setVisibleGrid={setVisibleGrid} promotions={promotions}/>
            </Animated>
            }

            {edit &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={edit}>
                <PromotionsEditForm DataStore={DataStore} setVisibleGrid={setVisibleGrid} setEdit={setEdit}
                                    dataSource={dataEdit} setTrigger={setTrigger} trigger={trigger}
                                    setDataEdit={setDataEdit} promotions={promotions}/>
            </Animated>
            }


        </>
    )
}

export default inject('DataStore', 'ControlStore')(observer(Promotions));


function DiffCell(cellData) {
    return (
        <div>
            <span>{`${((cellData.data.percentage / 100) * 10000).toFixed(1)} %`}</span>
        </div>
    );
}
